<template>
        <v-expansion-panel title="Zusatzstoffe">
            <template #text>
                <v-list lines="two" density="compact">
                    <v-list-item v-for="item in additiveItems" :key="item.key">
                        <template #title>
                            <div class="icon-text">
                                <p>{{ item.label }}</p>
                                <div class="key">
                                    <span>{{ item.key }}</span>
                                </div>
                            </div>
                        </template>
                        <v-divider thickness="2" inset></v-divider>
                    </v-list-item>
                </v-list>
            </template>
        </v-expansion-panel>

        <v-expansion-panel title="Allergene">
            <template #text>
                <v-list lines="two" density="compact">
                    <v-list-item v-for="item in allergenItems" :key="item.key">
                        <template #title>
                            <div class="icon-text">
                                <p>{{ item.label }}</p>
                                <div class="key">
                                    <span>{{ item.key }}</span>
                                </div>
                            </div>
                        </template>
                        <v-divider thickness="2" inset></v-divider>
                    </v-list-item>
                </v-list>
            </template>
        </v-expansion-panel>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import { ingredientMap, allergensMap } from '@/collections/zusatzstoffe';

export default defineComponent({
    name: 'ExpansionPanelZusatzstoffe',

    setup() {
        const additiveItems = computed(() =>
            Object.entries(ingredientMap).map(([k, v]) => ({ key: k, label: v }))
        );

        const allergenItems = computed(() =>
            Object.entries(allergensMap).map(([k, v]) => ({ key: k, label: v }))
        );

        return {
            additiveItems,
            allergenItems
        };
    }
});
</script>

<style scoped>
.icon-text {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.icon-text>p {
    padding-right: 10px;
}
</style>
